// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root Zone WP Styles */

.root-zone-wp {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background-color: var(--color-grey-99);
  background-color: var(--color-grey-99);
  border-radius: 8px;
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  min-width: 150px;
}

.root-zone-wp--empty {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.root-zone-wp__header {
  display: flex;
  align-items: center;
}

.root-zone-wp__value {
  display: flex;
  align-items: center;
}

.root-zone-wp__date {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/RootZoneWP.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Root Zone WP Styles */\n\n.root-zone-wp {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  background-color: var(--color-grey-99);\n  background-color: var(--color-grey-99);\n  border-radius: 8px;\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n  min-width: 150px;\n}\n\n.root-zone-wp--empty {\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.root-zone-wp__header {\n  display: flex;\n  align-items: center;\n}\n\n.root-zone-wp__value {\n  display: flex;\n  align-items: center;\n}\n\n.root-zone-wp__date {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
